export const ORDER_STATUSES = {
  pending: 0,
  created: 1,
  pendingCoding: 2,
  completed: 3
};
